<template>
  <div>DEPRECATED PLEASE USE p-dynamic-form</div>
</template>

<script lang="ts">
  import Vue from 'vue';

  /** @deprecated Please use p-dynamic-form instead */
  export default Vue.extend({
    name: 'PDynamicFormFields',
    props: {
      value: { type: Array, default: undefined },
      definition: { type: [Array, String], default: () => [] },
      depth: { type: Number, default: 0 },
      groupsAreAccordions: { type: Boolean, default: false },
      jsonSchema: { type: Object, default: undefined },
      noValidation: { type: Boolean, default: false },
    },
    data: () => ({
    }),
  });
</script>
